// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-views-pages-page-tsx": () => import("/opt/build/repo/src/views/pages/Page.tsx" /* webpackChunkName: "component---src-views-pages-page-tsx" */),
  "component---src-views-pages-news-post-news-post-tsx": () => import("/opt/build/repo/src/views/pages/NewsPost/NewsPost.tsx" /* webpackChunkName: "component---src-views-pages-news-post-news-post-tsx" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

